<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  workstations.id
                    ? "Editar Estação de Trabalho"
                    : "Cadastrar Estação de Trabalho"
                }}
              </div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="title">
                            <span class="required">*</span> Titulo:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.title"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDepartment">
                            <span class="required">*</span> Empresa
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="workstations.company_id"
                            v-on:input="getBranches()"
                          >
                            <div slot="no-options">
                              Nenhum registro encontrado.
                            </div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="branch_id">
                            <span class="required">*</span> Filial/Prédio:
                          </label>
                          <v-select
                            :options="branches"
                            v-if="loadBranch"
                            label="title"
                            :reduce="(branches) => branches.id"
                            class="style-chooser"
                            v-model="workstations.branch_id"
                          >
                            <div slot="no-options">
                              Nenhum registro encontrado.
                            </div>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="tag">
                            <span class="required">*</span> Tag:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.tag"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="numberRoom"> Nº da Sala: </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.number_room"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="floor"> Andar: </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="workstations.floor"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="capacity">
                            <span class="required">*</span> Quantidade de
                            Posições:
                          </label>
                          <input
                            type="number"
                            min="0"
                            oninput="validity.valid||(value='');"
                            class="form-control"
                            v-model="workstations.capacity"
                            placeholder=""
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Descrição:
                          </label>
                          <textarea
                            v-model="workstations.description"
                            name="description"
                            cols="100"
                            class="form-control"
                            rows="10"
                            placeholder=""
                            autocomplete="new-password"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="RoomDetails">Contém na Sala:</label>
                          <br />
                        </div>
                      </div>
                      <div
                        class="col-md-1 lg-check"
                        style="text-align: center"
                        v-for="detail in details"
                        :key="detail.id"
                      >
                        <input
                          type="checkbox"
                          :value="detail.id"
                          v-model="checkeds"
                          :id="detail.id"
                          @change="clear()"
                        />
                        <label :for="detail.id">{{ detail.title }}</label>
                      </div>
                    </div>
                    <br />
                    <br />
                    <hr />
                    <div class="row">
                      <div class="col-md-6">
                        <label for="roomPic">
                          <span class="required">*</span>Foto da Estação de
                          Trabalho
                        </label>
                        <br />
                        <div
                          class="inlinee"
                          v-for="(image, key) in images"
                          :key="key"
                        >
                          <img :src="image.preview" class="preview" />
                        </div>
                        <div></div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="file"
                            class="form-control"
                            id="roomPic"
                            accept="image/jpeg, image/png"
                            name="roomPic"
                            @change="uploadImage"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label for="blueprint">
                          <span class="required">*</span>Planta Baixa do Andar
                        </label>
                        <div class="form-group">
                          <input
                            type="file"
                            class="form-control"
                            id="blueprint"
                            accept="image/jpeg, image/png"
                            name="blueprint"
                          />
                        </div>
                      </div>
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/workstations" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Switch from "../Utils/Checked.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
      images: [],
      blueprint: [],
      workstations: {
        title: "",
        description: "",
        tag: "",
        floor: "",
        number_room: "",
        company_id: "",
        capacity: "",
        photo: "",
        branch_id: "",
      },
      checkeds: [],
      companies: [],
      branches: [],
      details: {
        selected: "",
      },
      details: "",
      loadBranch: true,
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();
      let photo = document.getElementById("roomPic");
      let blueprint = document.getElementById("blueprint");
      fd.append("title", self.workstations.title);
      fd.append("description", self.workstations.description);
      fd.append("tag", self.workstations.tag);
      fd.append("floor", self.workstations.floor);
      fd.append("number_room", self.workstations.number_room);
      fd.append("capacity", self.workstations.capacity);
      fd.append("branch_id", self.workstations.branch_id);
      fd.append("company_id", self.workstations.company_id);
      fd.append("details", self.checkeds);
      fd.append("photo", photo.files[0] ? photo.files[0] : "");
      fd.append("blueprint", blueprint.files[0] ? blueprint.files[0] : "");
      if (self.$route.params.id) {
        fd.append("id", self.$route.params.id);
        fd.append("_method", "PUT");
      }
      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "workstations";
      let fd = self.makeFormData();
      if (self.$route.params.id) {
        api += "/" + self.$route.params.id;
      }
      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/workstations");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        console.log(selectedFiles[i]);
        this.images.push({ file: selectedFiles[i], preview: "" });
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.images[i].preview = e.target.result;
        };

        reader.readAsDataURL(this.images[i].file);
      }
    },
    uploadBlueprint(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        console.log(selectedFiles[i]);
        this.blueprint.push({ file: selectedFiles[i], preview: "" });
      }

      for (let i = 0; i < this.blueprint.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.blueprint[i].preview = e.target.result;
        };

        reader.readAsDataURL(this.blueprint[i].file);
      }
    },
    getWorkstationDetails: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "workstation_details/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "branches/?paginated=false&company_id=" +
        self.workstations.company_id;

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getWorkstations: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api + "workstations/" + id + "?with[]=details";

      self.$http
        .get(api)
        .then((response) => {
          self.workstations = response.data.data[0];

          self.workstations.details.forEach((detail, index) => {
            self.checkeds.push(detail.detail_id);
          });
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getCompanies();
    // self.getBranches();
    self.getWorkstationDetails();
    let id = self.$route.params.id;
    if (id) {
      self.getWorkstations(id);
    }
  },
  watch: {
    value(val) {
      this.text = val ? "Yes" : "No";
    },
  },
  components: {
    vSelect,
    "app-switch": Switch,
  },
};
</script>
<style scoped>
.photo {
  display: flex;
  border-radius: 20px;
  max-width: 400px;
  max-height: 200px;
  object-fit: cover;
}
.preview {
  display: inline-block;
  border-radius: 20px;
  max-width: 200px;
  max-height: 100px;
  object-fit: cover;
}
.inlinee {
  display: inline-block;
}

.lg-check {
  margin: 20px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Workstations/Add.vue